const legacyNavApi = require('../js/nav.js');
legacyNavApi.init();
window.define('orb/nav', legacyNavApi);
